import { Observable } from 'rxjs';

import { HttpClient, HttpResponse } from '@angular/common/http';

import { CxsBasket } from '../model';

export const getBasket = (
    httpClient: HttpClient,
    basketId: string = '',
    customerEmail?: string
): Observable<CxsBasket> =>
    httpClient.get<CxsBasket>(`orders-ms/basket/${basketId}`, { params: { customerEmail: customerEmail ?? '' } });

export const getBasketWithHeaders = (
    httpClient: HttpClient,
    basketId: string = '',
    customerEmail?: string
): Observable<HttpResponse<CxsBasket>> =>
    httpClient.get<CxsBasket>(`orders-ms/basket/${basketId}`, {
        observe: 'response',
        params: { customerEmail: customerEmail ?? '' }
    });
